"use strict";

exports.__esModule = true;
exports.appendTimestamp = appendTimestamp;
exports.getHost = getHost;
exports.downGrade = downGrade;
/* eslint-disable */
/**
 * 拼接时间戳，有则更新
 * @param url
 */
function appendTimestamp(url) {
  if (url.match(new RegExp("(\\?|&)" + "_t" + "=([^&]*)(&|$)"))) {
    // 存在则更新
    url = url.replace(RegExp.$2, new Date().getTime());
  } else {
    url += (url.indexOf("?") > -1 ? "&" : "?") + ("_t=" + new Date().getTime());
  }
  return url;
}

/**
 * 获取url的host
 * @param url
 * @returns {*|string}
 */
function getHost(url) {
  var a = document.createElement("a");
  a.href = url;
  return a.host;
}

/**
 * https降级到http
 * @param url
 */
function downGrade(url) {
  if (/^https/gi.test(url)) {
    return url.replace(/^https/gi, "http");
  } else {
    // 可能会是相对路径'//pic.url.cn'等
    return url.indexOf("http") > -1 ? url : "http:" + url;
  }
}